// Per-locale guide content, keyed by the 12 catalog codes the `locale` page prop
// can carry (see ApplicationController#current_locale). English is the source
// (content/en.js); the others mirror its shape (enforced by
// scripts/check-guide-content.mjs). Missing locales fall back to English.
import en from './en'
import es from './es'
import de from './de'
import fr from './fr'
import it from './it'
import ja from './ja'
import ko from './ko'
import nl from './nl'
import da from './da'
import nb from './nb'
import ptBR from './pt-BR'
import zhHant from './zh-Hant'

export const GUIDE_CONTENT = {
  en,
  es,
  de,
  fr,
  it,
  ja,
  ko,
  nl,
  da,
  nb,
  'pt-BR': ptBR,
  'zh-Hant': zhHant,
}

export function guideContent(locale) {
  return GUIDE_CONTENT[locale] || GUIDE_CONTENT[String(locale).split('-')[0]] || en
}
